<template>
  <d-card class="card-small go-stats">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ $t("dashboard.campaignprogress") }}</h6>
    </d-card-header>

    <d-card-body class="py-0">
      <!-- Goals Overview List Group -->
      <d-list-group flush class="list-group-small">
        <ao-single-goal v-for="(goal, idx) in campaignProgressData" :key="idx" :goal="goal" />
      </d-list-group>
    </d-card-body>

    <d-card-footer class="border-top">
      <d-row>
        <!-- Time Frame -->
        <d-col>
          <d-select size="sm" value="last-week" style="max-width: 130px;">
            <option value="today">{{ $t("dashboard.today") }}</option>
            <option value="last-week">{{ $t("dashboard.lastweek") }}</option>
            <option value="last-month">{{ $t("dashboard.lastmonth") }}</option>
            <option value="last-year">{{ $t("dashboard.lastyear") }}</option>
          </d-select>
        </d-col>

        <!-- View Full Report -->
        <!-- <d-col class="text-right view-report">
          <a href="#">View full report &rarr;</a>
        </d-col>-->
      </d-row>
    </d-card-footer>
  </d-card>
</template>

<script>
import colors from "@/utils/colors";
import SingleGoal from "./SingleGoal.vue";

const defaultCampaignProgressData = [
  {
    title: "Marketers in USA",
    completions: "291",
    value: "$192.00",
    conversionRate: "57.2%",
    data: {
      datasets: [
        {
          hoverBorderColor: "#fff",
          data: [57.2, 42.8],
          backgroundColor: [
            colors.primary.toRGBA(0.9),
            colors.athensGray.toRGBA(0.8)
          ]
        }
      ],
      labels: ["Label 1", "Label 2"]
    }
  }
];

export default {
  name: "ao-goals-overview",
  components: {
    aoSingleGoal: SingleGoal
  },
  props: {
    /**
     * The component title.
     */
    /**
     * The goals overview data.
     */
    campaignProgressData: {
      type: Array,
      default() {
        return defaultCampaignProgressData;
      }
    }
  }
};
</script>

